import React from 'react';
import { Col } from 'reactstrap';

const ActiveClients = ({ clients, type }) => {
  return (
    <Col className="row border-top mt-2 mx-1">
      <h6 className="text-start my-3 mt-4">
        {type === 'superadmin' ? 'All active' : 'Active'} employees per client
      </h6>
      {type === 'superadmin' && (
        <p className="text-muted adjust-fs">
          <i className="fa fa-eye-slash"></i> Now visible as Super Admin.
        </p>
      )}
      <div className="d-flex flex-wrap align-items-center justify-content-start gap-3 mb-4">
        {clients.map((client, index) => (
          <div
            key={index}
            className="p-4 bg-white d-flex flex-column align-items-center justify-content-center rounded-2 adjust-shadow"
            style={{
              border: '1px solid rgba(0, 0, 0, 0.125)',
              minWidth: '150px', // Ensures boxes don’t shrink too small
            }}
          >
            <p className="text-muted my-1 adjust-fs">{client.name}</p>
            <h5 className="fs-4">{client.associateCount}</h5>
          </div>
        ))}
      </div>
    </Col>
  );
};

export default ActiveClients;
